module.exports = __webpack_public_path__ + "img/ic-grab.17f77a7b.svg";